import AppConstants from '../config/app.constants';

let BatchService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/batch`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/batch/create`, {
                data,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/batch/${id}`, {
                params: {
                    branchId                
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data, branchId) => {
        return $http
            .post(AppConstants.api + `/batch/${id}`, {
                data,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/batch/${id}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

BatchService.$inject = ['$http', '$q']

export default BatchService;


// WEBPACK FOOTER //
// ./client/app/services/batch.service.js